// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "../PaymentInputField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function EmailField$EmailInput(props) {
  var fields = props.fields;
  var primaryFieldConfig = props.primaryFieldConfig;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var fieldRef = React.useRef(null);
  var form = ReactFinalForm.useForm();
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(primaryFieldConfig, localeString);
  var autocomplete = Core__Option.getOr(primaryFieldConfig.htmlAutocompleteAttribute, "email");
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(primaryFieldConfig, localeString);
  var primaryField = ReactFinalForm.useField(primaryFieldConfig.confirmRequestWritePath, {
        validate: validate
      });
  var value = Core__Option.getOr(primaryField.input.value, "");
  var invalid = primaryField.meta.invalid;
  var showError = primaryField.meta.touched && !primaryField.meta.active;
  var isValid = showError ? !invalid : undefined;
  var errorString = showError && invalid ? Core__Option.getOr(primaryField.meta.error, "") : "";
  return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
              isValid: Caml_option.some(isValid),
              value: value,
              onChange: (function (ev) {
                  var val = ev.target.value;
                  fields.forEach(function (field) {
                        form.change(field.confirmRequestWritePath, val);
                      });
                }),
              onBlur: (function (_ev) {
                  primaryField.input.onBlur();
                }),
              errorString: errorString,
              onFocus: (function (_ev) {
                  primaryField.input.onFocus();
                }),
              fieldName: match$1.label,
              name: DynamicFieldsUtils$OrcaPaymentPage.getFieldTestId(primaryFieldConfig.confirmRequestWritePath),
              placeholder: match$1.placeholder,
              inputRef: fieldRef,
              autocomplete: autocomplete
            });
}

var EmailInput = {
  make: EmailField$EmailInput
};

function EmailField(props) {
  var fields = props.fields;
  var primaryFieldConfig = fields[0];
  if (primaryFieldConfig !== undefined) {
    return React.createElement(EmailField$EmailInput, {
                primaryFieldConfig: primaryFieldConfig,
                fields: fields
              });
  } else {
    return null;
  }
}

var make = EmailField;

export {
  EmailInput ,
  make ,
}
/* jotai Not a pure module */
